import { type RootState } from "app";
import { featuresConfig } from "config/features";

export const selectPlaneIndex = (state: RootState) => state.crossSection.planeIndex;
export const selectDisplaySettings = (state: RootState) => state.crossSection.displaySettings;
export const selectCrossSectionActivePlaneIdx = (state: RootState) =>
    state.explorer.widgets.includes(featuresConfig.crossSection.key) ? state.crossSection.planeIndex : null;
